export default __webpack_public_path__ + "static/media/source-sans-pro-v12-latin-600.720fb921.woff";